"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberRole = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
var MemberRole;
(function (MemberRole) {
    MemberRole["OWNER"] = "OWNER";
    MemberRole["ADMIN"] = "ADMIN";
    MemberRole["MEMBER"] = "MEMBER";
    MemberRole["Owner"] = "OWNER";
    MemberRole["Admin"] = "ADMIN";
    MemberRole["Member"] = "MEMBER";
})(MemberRole || (exports.MemberRole = MemberRole = {}));
